export function ChartSkeleton() {
  return (
    <div className="animate-pulse">
      <div className="mb-4 flex gap-4">
        {[1, 2, 3].map((i) => (
          <div key={i} className="h-20 flex-1 rounded-xl" style={{ backgroundColor: 'var(--color-surface-3)' }} />
        ))}
      </div>
      <div className="h-80 rounded-xl" style={{ backgroundColor: 'var(--color-surface-3)' }} />
    </div>
  );
}
